import React, { useState }  from 'react';
import { useLocation } from 'react-router-dom';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import BlueButton from './BlueButton';
import GameType from './GameType';
import HomeButton from './HomeButton';

import CoinImg from '../assets/GoldAcesChip.svg';
import DealerDotsCard from '../assets/dealerEmptyCard.svg';
import NFTDotsCard from '../assets/nftEmptyCard.svg';

import '../css/Table.scss';


export default function Table({game}) {
    const [pot, setPot] = useState(0);
    const [round, setRound] = useState(0);
    const [player_bet, setPlayerBet] = useState(100);
    const [player_total, setPlayerTotal] = useState(600);
    const location = useLocation();
    if(location.state) {
        game = location.state.game;
    }

    let deal = 1;
    if(game === 'war') {
        deal = 1;
    } else if (game === '3 card') {
        deal = 3;
    } else if (game === '5 card') {
        deal = 5;
    }
    

    const deal_played = [];
    const player_played = [];
    for (var i = 0; i < deal; i++) {
        deal_played.push(
            <div className='dealer-played-card' key={i}></div>
        );
        player_played.push(
            <div className={'player-played-card played-card-'+i} key={i}></div>
        );
    }

    const subtractBet = () => {
        if((player_bet - 100) > 99) {
            setPlayerBet(player_bet - 100);
        } else {
            setPlayerBet(100);
        }
    }
    const addBet = () => {
        setPlayerBet(player_bet + 100);
    }

    const placeBet = () => {
        if(player_total >= player_bet && player_total !== 0) { 
            setPot(pot+player_bet);
            setPlayerTotal(player_total - player_bet);
            setPlayerBet(100);
            setRound(round + 1);
        } else {
            toast.error('You can not make this bet!', {
                position: "top-center",
                autoClose: 5000,
                className:"error-toast-container",
                toastClassName:"error-toast",
                bodyClassName:"error-toast-body",
                progressClassName:"error-toast-progress",
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    const playAgain = () => {
        console.log('start another game');
        setRound(1);
        setPot(0);
        setPlayerBet(100);
    }

    const checkBet = () => {
        console.log('check the bet');
        setRound(round + 1);
    }

    const raiseBet = () => {
        console.log('raise bet');
        placeBet();
        setRound(round + 1);
    }

    return (
        <>
            <div className='game-header flex-container space-between'>
                <HomeButton type="return" content="Return Home" />
                <GameType />
            </div>
            <div className='table-container flex-container column-flex'>
                <div className='table'>
                    <div className='dealer-cards dealer-cards-pile'>
                        <img className='dealer-cards' src={DealerDotsCard} alt="card full of dots" />
                    </div>
                    <div className='dealer-cards dealer-in-play'>
                        {deal_played}
                    </div>
                    <div className='dealer-cards dealer-discard-pile'>
                        <img className='dealer-discard' src={DealerDotsCard} alt="card full of dots" />
                    </div>
                    <hr className='middle-line first-line'></hr>
                    <div className='pot flex-container'>
                        <h2 className='pot-title'>Pot: {pot}</h2>
                        <img src={CoinImg} className='pot-coin' alt="gold coin with a skull on it" />
                    </div>
                    <hr className='middle-line second-line'></hr>
                    <div className='player-cards-container player-discard-pile'>
                        <p className='card-label'>Discard Pile</p>
                        <img className='player-discard' src={NFTDotsCard} alt="card full of dots" />
                    </div>
                    <div className='player-cards-container player-in-play'>
                        <p className='card-label'>In Play</p>
                        <div className=''>
                            <div className='player-in-play-container'>
                                {player_played}
                            </div>
                        </div>
                    </div>
                    <div className='player-cards-container player-cards-pile'>
                        <p className='card-label'>Your Cards</p>
                        <img className='player-cards' src={NFTDotsCard} alt="card full of dots" />
                    </div>
                </div>
            </div>
            <div className='game-footer-container flex-container'>
                <div className='game-footer flex-container space-between'>
                    <div className='player-bet-container'>
                        <div className='flex-container column-flex'>
                            <div className='player-bet flex-container'>
                                <div className='minus-btn' onClick={subtractBet}>
                                    <p className='btn-icon flex-container'>-</p>
                                </div>
                                    <div className='bet-container flex-container'>
                                        <h2 className='bet'>{player_bet}</h2>
                                        <img src={CoinImg} className="player-coin" alt="gold coin with a skull on it" />
                                    </div>
                                <div className='plus-btn' onClick={addBet}>
                                    <p className='btn-icon flex-container'>+</p>
                                </div>
                            </div>
                            <p className='bet-label'>Bet Amount</p>
                        </div>
                    </div>
                    {round === 0 && 
                        <BlueButton content="Bet" type="bet" action={placeBet} />}
                    {round > 1 && (game === '3 card' || game === '5 card') && 
                        <div className='in-game-action'>
                            <button className='check-btn' onClick={checkBet}>Check</button>
                            <button className='raise-btn' onClick={raiseBet}>Raise</button>
                        </div>}
                    {((round === 1 && game === 'war') ||(round === 2 && game === '3 card') || (round === 4 && game === '5 card')) && 
                        <BlueButton content="Play Again" action={playAgain} />
                    }
                    <div className='total-spaces-container'>
                        <div className='spaces-amt-container flex-container'>
                            <p className='spaces-amt'>{player_total}</p>
                            <img className='spaces-img' src={CoinImg} alt="gold coin with a skull on it" />
                        </div>
                        <p className='total-spaces-label'>Total $PACES</p>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}